export default function WhyJapan() {
  const benefits = [
    {
      icon: '/img/gijinkoku/mingcutecertificate-line.svg',
      title: 'Peluang jadi PR Tinggi',
      description:
        'Visa kerja Gijinkoku bisa diperpanjang tanpa batas dan lebih dipercaya sebagai jalur menuju Permanent Residence.',
    },
    {
      icon: '/img/gijinkoku/material-symbolswork-outline.svg',
      title: 'Gaji Hingga Rp50 Juta/Bulan',
      description:
        'Gaji yang kompetitif dan nilai tukar yang kuat memberikan peluang menabung lebih banyak dan kestabilan finansial.',
    },
    {
      icon: '/img/gijinkoku/carbondata-structured.svg',
      title: 'Tingginya Permintaan Pekerja',
      description:
        'Peluang kerja di Jepang besar, namun Jepang kekurangan tenaga kerja lokal.',
    },
  ]

  return (
    <section className="bg-gray-50 py-10">
      <div className="mx-auto max-w-6xl px-6">
        <div className="mb-12 text-center">
          <h2 className="mb-4 text-3xl font-bold text-gray-700">
            Why work in Japan?
          </h2>
        </div>

        <div className="grid gap-8 md:grid-cols-3">
          {benefits.map((benefit, index) => (
            <div key={index} className="p-6 text-center">
              <div className="mb-4 flex items-center justify-center">
                <div className="flex h-12 w-12 items-center justify-center rounded border border-gray-300 bg-white">
                  <img src={benefit.icon} alt="Icon" className="h-6 w-6" />
                </div>
              </div>
              <div>
                <h3 className="mb-3 text-xl font-semibold text-gray-700">
                  {benefit.title}
                </h3>
                <p className="text-sm leading-relaxed text-gray-600">
                  {benefit.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
